<template>
  <div>
    <div class="sceneWrapper">
      <div class="sceneWrapper__slider">
        <div class="sceneWrapper__item" :data-scene-id="scene.sceneId"
             v-for="(scene, index) in listing">
          <scene-detail :item="scene" :index="index"></scene-detail>
        </div>
      </div>
      <div class="sceneWrapper__controls" v-show="isNavVisible">
        <div class="btn btn--prev">
          <icon-arrow></icon-arrow>
        </div>
        <div class="btn btn--next">
          <icon-arrow></icon-arrow>
        </div>
      </div>
      <div class="sceneWrapper__nav" v-show="isNavVisible">
        <div v-for="item in listing">
          <button :class="item.sceneId"></button>
          <span v-html="item.titleForPager"></span>
        </div>
      </div>
    </div>
    <button class="sceneWrapper__tutorialBtn inactive" @click="toggleVideoOverlay">
      <!-- {{tutorialLabel}} -->
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 160 160"><circle class="st0" cx="80.3" cy="79.6" r="73"/><path class="st1" d="M64.7 45.9c4-2.6 8.8-3.8 14.6-3.8 7.6 0 13.9 1.8 18.9 5.4 5 3.6 7.5 9 7.5 16.1 0 4.4-1.1 8.1-3.3 11.1 -1.3 1.8-3.7 4.1-7.3 7l-3.6 2.8c-1.9 1.5-3.2 3.3-3.9 5.3 -0.4 1.3-0.6 3.3-0.7 6H73.4c0.2-5.7 0.7-9.6 1.6-11.8 0.9-2.2 3.1-4.7 6.7-7.5l3.7-2.9c1.2-0.9 2.2-1.9 2.9-3 1.3-1.8 2-3.9 2-6.1 0-2.6-0.7-4.9-2.2-7 -1.5-2.1-4.2-3.2-8.2-3.2 -3.9 0-6.7 1.3-8.3 3.9 -1.6 2.6-2.4 5.3-2.4 8.1H54.7C55.1 56.7 58.4 49.9 64.7 45.9zM73.1 102.6h15.1v14.6H73.1V102.6z"/></svg>
    </button>
    <overlay-tutorial v-if="hasTutorialOverlay" @close-video-overlay="closeVideoOverlay"></overlay-tutorial>
    <scene-search v-if="searchBoxVisibility"></scene-search>
  </div>

</template>
<script>
  import SceneDetail from './SceneDetail'
  import SceneSearch from './SceneSearch'
  import Arrow from './icons/Arrow'
  import Tutorial from './OverlayTutorial'

  var theSlider;

  export default{
    props: ['items'],
    data(){
      return {
        listing: [],
        hasTutorialOverlay: false,
        tutorialLabel: '',
        tutorialLabelOpen: '',
        tutorialLabelClose: ''
      }
    },
    components: {
      'scene-detail': SceneDetail,
      'scene-search': SceneSearch,
      'icon-arrow': Arrow,
      'overlay-tutorial': Tutorial
    },
    computed: {
      searchBoxVisibility(){
        return this.$store.state.interface.isSearchVisible;
      },
      isNavVisible(){
        return this.$store.state.interface.isVisible;
      }
    },
    methods: {
      toggleVideoOverlay(e){
        var vm = this;
        var btn = e.target;
        vm.hasTutorialOverlay = !vm.hasTutorialOverlay;
        vm.toggleClass(btn, 'inactive');
        setTimeout(function(){
          if(vm.hasClass(btn, 'inactive')){
            vm.tutorialLabel = vm.tutorialLabelOpen;
          }
          else{
            vm.tutorialLabel = vm.tutorialLabelClose;
          }
        }, 900);
      },
      openVideoOverlay(){
        this.hasTutorialOverlay = true;
      },
      closeVideoOverlay(){
        this.hasTutorialOverlay = false;
      }
    },
    watch: {
      listing() {
        var vm = this;
        theSlider = tns({
          container: '.sceneWrapper__slider',
          items: 1,
          slideBy: 1,
          controls: true,
          controlsContainer: '.sceneWrapper__controls',
          navContainer: '.sceneWrapper__nav',
          autoplay: false,
          loop: false,
          rewind: true,
          arrowKeys: true,
          speed: 600,
          navAsThumbnails: true,
          //mouseDrag: true,
          mouseDrag: false,
          //swipeAngle: 50,
          mode: 'carousel',
          startIndex: vm.$store.state.activeSlide,
          responsive: {
            767: {
              swipeAngle: false,
              mouseDrag: false,
              touch: false,
              slideBy: 'page',
              items: 1
            }
          },
          onInit: onInit
        });
        theSlider.events.on('transitionStart', onTransitionStart);
        theSlider.events.on('transitionEnd', onTransitionEnd);

        function onInit() {

          var lFollowX = 0,
            lFollowY = 0,
            x = 0,
            y = 0,
            friction = 1 / 30;

          var bgElements = document.querySelectorAll('.sceneDetail__background .bg');

          function moveBackground() {
            x += (lFollowX - x) * friction;
            y += (lFollowY - y) * friction;
            var translate = 'translate(' + x + 'px, ' + y + 'px) scale(1.1)';
            for(var i = 0; i < bgElements.length; i++){
              var bgEl = bgElements[i];
              bgEl.style.transform = translate;
            }
            window.requestAnimationFrame(moveBackground);
          }

          moveBackground();

          window.addEventListener('mousemove', function (e) {
            var lMouseX = Math.max(-100, Math.min(100, window.innerWidth / 2 - e.clientX));
            var lMouseY = Math.max(-100, Math.min(100, window.innerHeight / 2 - e.clientY));
            lFollowX = (20 * lMouseX) / 100; // 100 : 12 = lMouxeX : lFollow
            lFollowY = (10 * lMouseY) / 100;
          });

          eventTracking.send({
            category: 'SceneSlider',
            action: 'ViewSlide',
            label: document.getElementsByClassName('sceneWrapper__slider')[0].childNodes[0].getAttribute("data-scene-id")
          });

        }

        function onTransitionStart() {

          let info = theSlider.getInfo(),
            indexPrev = info.indexCached,
            indexCurrent = info.index;

          info.slideItems[indexPrev].classList.remove('animate-in-end');
          //info.slideItems[indexCurrent].classList.remove('animate-out');
          info.slideItems[indexCurrent].classList.add('animate-in-start');

          eventTracking.send({
            category: 'SceneSlider',
            action: 'ViewSlide',
            label: info.container.childNodes[indexCurrent].getAttribute("data-scene-id")
          });

        }

        function onTransitionEnd() {

          let info = theSlider.getInfo(),
            indexPrev = info.indexCached,
            indexCurrent = info.index;

          //info.slideItems[indexPrev].classList.add('animate-out');
          //console.log(info.slideItems[indexCurrent]);
          info.slideItems[indexCurrent].classList.remove('animate-in-start');
          info.slideItems[indexCurrent].classList.add('animate-in-end');

        }

      }
    },
    mounted(){
      this.$store.state.hasApplicationLoaded = true;
      this.$store.state.interface.isWhite = true;
      if (theSlider) {
        theSlider.goTo(this.$store.state.activeSlide);
      }
    },
    created(){

      var url = document.querySelector('#root').getAttribute('data-endpoint-listing');
      var vm = this;
      //var myHeaders = new Headers();
      //myHeaders.append("Authorization", 'Basic ' + btoa('demo:dgtnext2015'));
      vm.tutorialLabelOpen = vm.$store.state.labels.sceneSelector.tutorialLabelOpen;
      vm.tutorialLabelClose = vm.$store.state.labels.sceneSelector.tutorialLabelClose;
      vm.tutorialLabel = vm.tutorialLabelOpen;

      if (vm.$store.state.sceneListing.length) {
        vm.listing = vm.$store.state.sceneListing;
      }
      else {
        fetch(url, {
          credentials: "include"
          //headers: myHeaders
        })
          .then(function (response) {
            return response.json();
          })
          .catch(function () {
            vm.$router.push('/');
          })
          .then(function (data) {
            if (data.header.success) {
              vm.$store.state.sceneListing = data.data;
              vm.listing = vm.$store.state.sceneListing;
            }
            else {
              vm.$router.push('/');
            }
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SceneWrapper.vue